/* eslint-disable @typescript-eslint/no-explicit-any */
import { extractPageNumber, findPdfPathByPolicyCode } from './policy-reference.utils'

interface OpenPolicyPdfArgs {
  pdfPath?: string
  policyCode?: string | number
  page?: string | number
  comparisonPolicies?: any[]
  selectedPolicyContents?: any[]
  mediaBaseUrl: string
}

export function openPolicyPdfWithContext({
  pdfPath,
  policyCode,
  page,
  comparisonPolicies = [],
  selectedPolicyContents = [],
  mediaBaseUrl,
}: OpenPolicyPdfArgs): void {
  const pageNumber = page ? extractPageNumber(page.toString()) : null

  if (pdfPath) {
    const pdfUrl = `${mediaBaseUrl}/${pdfPath}${page && pageNumber ? `#page=${pageNumber}` : ''}`
    window.open(pdfUrl, '_blank', 'noopener,noreferrer')
    return
  }

  if (policyCode) {
    const foundPdfPath = findPdfPathByPolicyCode(
      policyCode.toString(),
      comparisonPolicies,
      selectedPolicyContents,
    )
    if (foundPdfPath) {
      const pageNumber = page ? extractPageNumber(page.toString()) : null
      const pdfUrl = `${mediaBaseUrl}/${foundPdfPath}${
        page && pageNumber ? `#page=${pageNumber}` : ''
      }`
      window.open(pdfUrl, '_blank', 'noopener,noreferrer')
    }
  }
}
